import { render, staticRenderFns } from "./DanhGiaList.vue?vue&type=template&id=45c878f4"
import script from "./DanhGiaList.vue?vue&type=script&lang=js"
export * from "./DanhGiaList.vue?vue&type=script&lang=js"
import style0 from "./DanhGiaList.vue?vue&type=style&index=0&id=45c878f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports